import React from "react";
import { Marker, useMapEvents } from "react-leaflet";
import { LayerVisibility, ParcelData } from "../types";
import { GenerationUnit } from "../../../types";
import BaseMap from "../BaseMap";
import LayerManager from "../layers/LayerManager";
import { useAutoZoomToPolygon } from "../hooks/useAutoZoomToPolygon";
import { createWindmillIcon } from "./WindmillMarkerIcon";

const AutoZoomHandler: React.FC<{
  flaeche: [number, number][];
  anlagen: [number, number][];
}> = ({ flaeche, anlagen }) => {
  useAutoZoomToPolygon(flaeche, anlagen);
  return null;
};

const MapClickHandler: React.FC<{
  onMapClick: (lat: number, lon: number) => void;
}> = ({ onMapClick }) => {
  useMapEvents({
    click(e) {
      onMapClick(e.latlng.lat, e.latlng.lng);
    },
  });
  return null;
};

interface MapRendererProps {
  center: [number, number];
  zoom: number;
  projectName: string;
  flaecheCoordinates: [number, number][];
  anlagenCoordinates: [number, number][];
  anlagen: GenerationUnit[];
  layerVisibility: LayerVisibility;
  parcels?: ParcelData[];
  onParcelUpdate?: (updatedParcel: any) => void;
  onParcelClick?: (parcelId: string) => void;
  selectedParcelId?: string;
  selectedAnlageId?: string;
  onAnlagePositionChange?: (
    unitId: string,
    breitengrad: number,
    laengengrad: number,
  ) => void | Promise<void>;
  onAnlageSelect?: (unitId: string) => void;
  onMapClick?: (lat: number, lon: number) => void;
  standortLocation?: [number, number];
}

const MapRenderer: React.FC<MapRendererProps> = ({
  center,
  zoom,
  projectName,
  flaecheCoordinates,
  anlagenCoordinates,
  anlagen,
  layerVisibility,
  parcels,
  onParcelUpdate,
  onParcelClick,
  selectedParcelId,
  selectedAnlageId,
  onAnlagePositionChange,
  onAnlageSelect,
  onMapClick,
  standortLocation,
}) => {
  return (
    <BaseMap
      center={center}
      zoom={zoom}
      height="100%"
      showZoomControl
      attributionAlign="right"
    >
      <AutoZoomHandler
        flaeche={flaecheCoordinates}
        anlagen={anlagenCoordinates}
      />

      {onMapClick && <MapClickHandler onMapClick={onMapClick} />}

      {standortLocation && (
        <Marker
          position={standortLocation}
          icon={createWindmillIcon()}
          interactive={false}
        />
      )}

      <LayerManager
        parcels={parcels}
        layerVisibility={layerVisibility}
        projectName={projectName}
        flaecheCoordinates={flaecheCoordinates}
        anlagen={anlagen}
        onParcelUpdate={onParcelUpdate}
        onParcelClick={onParcelClick}
        selectedParcelId={selectedParcelId}
        selectedAnlageId={selectedAnlageId}
        onAnlagePositionChange={onAnlagePositionChange}
        onAnlageSelect={onAnlageSelect}
      />
    </BaseMap>
  );
};

export default MapRenderer;
